import { TipoLocalizacaoEnum } from 'graphql/types.generated'

import { RadioGroupField, RadioGroupFieldProps, RadioOption } from './RadioGroupField'

type TipoLocalizacaoRadioGroupFieldProps = Omit<RadioGroupFieldProps<TipoLocalizacaoEnum>, 'options'>

export function TipoLocalizacaoRadioGroupField(props: Readonly<TipoLocalizacaoRadioGroupFieldProps>) {
  return <RadioGroupField options={options} {...props} />
}

const options: RadioOption<TipoLocalizacaoEnum>[] = [
  { value: TipoLocalizacaoEnum.URBANA, label: 'Urbana' },
  { value: TipoLocalizacaoEnum.RURAL, label: 'Rural' },
  { value: TipoLocalizacaoEnum.PERIURBANA, label: 'Periurbana' },
]
